import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'Invoice No',
     label: 'Invoice No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'invoiceDate',
     field: FIELDS.INVOICE_DATE,
     title: 'InvoiceDate',
     label: 'InvoiceDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dueDate',
     field: FIELDS.DUE_DATE,
     title: 'DueDate',
     label: 'DueDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'aging',
     field: FIELDS.AGING,
     title: 'Aging',
     label: 'Aging',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesOrderId',
     field: FIELDS.SALES_ORDER_ID,
     title: 'Sales Order No',
     label: 'Sales Order No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contact',
     field: FIELDS.CONTACT,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingAddress',
     field: FIELDS.BILLING_ADDRESS,
     title: 'Bill To',
     label: 'Bill To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress',
     field: FIELDS.SHIPPING_ADDRESS,
     title: 'Ship To',
     label: 'Ship To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'billingTermName',
     field: FIELDS.BILLING_TERM_NAME,
     title: 'Terms',
     label: 'Terms',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isAuthorized',
     field: FIELDS.IS_AUTHORIZED,
     title: 'Authorized',
     label: 'Authorized',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subTotal',
     field: FIELDS.SUB_TOTAL,
     title: 'Sub Total',
     label: 'Sub Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalLineCost',
     field: FIELDS.TOTAL_LINE_COST,
     title: 'Total Line Cost',
     label: 'Total Line Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxable',
     field: FIELDS.TOTAL_CHARGES_TAXABLE,
     title: 'Total Charges Taxable',
     label: 'Total Charges Taxable',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxable',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
     title: 'Total Charges Non-Taxable',
     label: 'Total Charges Non-Taxable',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalCharges',
     field: FIELDS.TOTAL_CHARGES,
     title: 'Total Charges',
     label: 'Total Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalChargesCost',
     field: FIELDS.TOTAL_CHARGES_COST,
     title: 'Total Charges Cost',
     label: 'Total Charges Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'grossProfit',
     field: FIELDS.GROSS_PROFIT,
     title: 'Gross Profit',
     label: 'Gross Profit',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'gpMargin',
     field: FIELDS.GPMARGIN,
     title: 'GP Margin',
     label: 'GP Margin',
     cell: 'formatPercentage',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'amountPaid',
     field: FIELDS.AMOUNT_PAID,
     title: 'Amount Paid',
     label: 'Amount Paid',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'balance',
     field: FIELDS.BALANCE,
     title: 'Balance',
     label: 'Balance',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'authorizedByUserFullName',
     field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
     title: 'Authorized By',
     label: 'Authorized By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateAuthorized',
     field: FIELDS.DATE_AUTHORIZED,
     title: 'Date Auth',
     label: 'Date Auth',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'incoTermName',
     field: FIELDS.INCO_TERM_NAME,
     title: 'Inco Terms',
     label: 'Inco Terms',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipDate',
     field: FIELDS.SHIP_DATE,
     title: 'Ship Date',
     label: 'Ship Date',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerPo',
     field: FIELDS.CUSTOMER_PO,
     title: 'Customer PO',
     label: 'Customer PO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch Rate',
     label: 'Exch Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippedByUserFullName',
     field: FIELDS.SHIPPED_BY_USER_FULL_NAME,
     title: 'Shipped By',
     label: 'Shipped By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxRate',
     field: FIELDS.TAX_RATE,
     title: 'Tax Rate',
     label: 'Tax Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isTaxable',
     field: FIELDS.IS_TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxNumber',
     field: FIELDS.TAX_NUMBER,
     title: 'Tax Number',
     label: 'Tax Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vatNumber',
     field: FIELDS.VATNUMBER,
     title: 'VAT Number',
     label: 'VAT Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tax',
     field: FIELDS.TAX,
     title: 'Tax',
     label: 'Tax',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subTotalConverted',
     field: FIELDS.SUB_TOTAL_CONVERTED,
     title: 'Sub Total Converted',
     label: 'Sub Total Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCostConverted',
     field: FIELDS.TOTAL_LINE_COST_CONVERTED,
     title: 'Total Line Cost Converted',
     label: 'Total Line Cost Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
     title: 'Total Charges Taxable Converted',
     label: 'Total Charges Taxable Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
     title: 'Total Charges Non Taxable Converted',
     label: 'Total Charges Non Taxable Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesConverted',
     field: FIELDS.TOTAL_CHARGES_CONVERTED,
     title: 'Total Charges Converted',
     label: 'Total Charges Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCostConverted',
     field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
     title: 'Total Charges Cost Converted',
     label: 'Total Charges Cost Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalConverted',
     field: FIELDS.TOTAL_CONVERTED,
     title: 'Total Converted',
     label: 'Total Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesRepCommissionRate',
     field: FIELDS.SALES_REP_COMMISSION_RATE,
     title: 'Sales Rep Commission Rate',
     label: 'Sales Rep Commission Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'commissionAmount',
     field: FIELDS.COMMISSION_AMOUNT,
     title: 'Commission Amount',
     label: 'Commission Amount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isSalesCommissionPaid',
     field: FIELDS.IS_SALES_COMMISSION_PAID,
     title: 'Sales Commission Paid',
     label: 'Sales Commission Paid',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'creditAmount',
     field: FIELDS.CREDIT_AMOUNT,
     title: 'Credit Amount',
     label: 'Credit Amount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'credit',
     field: FIELDS.CREDIT,
     title: 'Credit',
     label: 'Credit',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipOnCompanyAccount',
     field: FIELDS.SHIP_ON_COMPANY_ACCOUNT,
     title: 'Ship On Company Account',
     label: 'Ship On Company Account',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'alwaysShipBy',
     field: FIELDS.ALWAYS_SHIP_BY,
     title: 'Always Ship By',
     label: 'Always Ship By',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'Tracking Number',
     label: 'Tracking Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalComments',
     field: FIELDS.INTERNAL_COMMENTS,
     title: 'Internal Comments',
     label: 'Internal Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipmentDetailsItn',
     field: FIELDS.SHIPMENT_DETAILS__ITN,
     title: 'ITN',
     label: 'ITN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipmentDetailsWeight',
     field: FIELDS.SHIPMENT_DETAILS__WEIGHT,
     title: 'Weight',
     label: 'Weight',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipmentDetailsCartons',
     field: FIELDS.SHIPMENT_DETAILS__CARTONS,
     title: 'Cartons',
     label: 'Cartons',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipmentDetailsDims1',
     field: FIELDS.SHIPMENT_DETAILS__DIMS1,
     title: 'Dims1',
     label: 'Dims1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipmentDetailsDims2',
     field: FIELDS.SHIPMENT_DETAILS__DIMS2,
     title: 'Dims2',
     label: 'Dims2',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
